/* Copyright (C) NewFoundry 2022 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.style = exports.name = exports.Tabs = void 0;

var react_1 = __importDefault(require("react"));

var StyleUtils_1 = __importDefault(require("./utils/StyleUtils"));

var name = 'Tabs';
exports.name = name;

var Tabs = function Tabs(_ref) {
  var Frame = _ref.Frame,
      Text = _ref.Text,
      styles = _ref.styles;
  return /*#__PURE__*/function (_react_1$default$Pure) {
    _inherits(_class, _react_1$default$Pure);

    var _super = _createSuper(_class);

    function _class(props) {
      var _this;

      _classCallCheck(this, _class);

      _this = _super.call(this, props);
      _this.state = {
        selected: 0
      };
      _this.selectTab = _this.selectTab.bind(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(_class, [{
      key: "selectTab",
      value: function selectTab(selected) {
        var _this$props = this.props,
            onTabSelected = _this$props.onTabSelected,
            _this$props$overrideO = _this$props.overrideOnClick,
            overrideOnClick = _this$props$overrideO === void 0 ? [] : _this$props$overrideO;

        if (overrideOnClick[selected]) {
          overrideOnClick[selected]();
          return;
        }

        this.setState({
          selected: selected
        }, function () {
          if (onTabSelected) {
            onTabSelected(selected);
          }
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            activeTab = _this$props2.activeTab,
            after = _this$props2.after,
            before = _this$props2.before,
            classes = _this$props2.classes,
            _this$props2$tabs = _this$props2.tabs,
            tabs = _this$props2$tabs === void 0 ? [] : _this$props2$tabs;
        var selected = this.state.selected;
        var isSelected = activeTab !== undefined ? activeTab : selected;
        return react_1.default.createElement(Frame, {
          className: ['Tabs__container', classes === null || classes === void 0 ? void 0 : classes.container],
          style: styles === null || styles === void 0 ? void 0 : styles.container
        }, before, tabs.map(function (t, i) {
          var style = Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.tab);

          if (isSelected === i) {
            Object.assign(style, styles === null || styles === void 0 ? void 0 : styles.selected);
          }

          return react_1.default.createElement(Frame, {
            className: ['Tabs__tab', classes === null || classes === void 0 ? void 0 : classes.tab],
            onClick: function onClick() {
              return _this2.selectTab(i);
            },
            style: styles === null || styles === void 0 ? void 0 : styles.tab
          }, react_1.default.createElement(Text, {
            className: ['Tabs__text', classes === null || classes === void 0 ? void 0 : classes.text],
            style: style
          }, t), isSelected === i && react_1.default.createElement(Frame, {
            className: ['Tabs__border-bottom', classes === null || classes === void 0 ? void 0 : classes.borderBottom],
            style: styles === null || styles === void 0 ? void 0 : styles.borderBottom
          }));
        }), after);
      }
    }]);

    return _class;
  }(react_1.default.PureComponent);
};

exports.Tabs = Tabs;

var style = function style(theme) {
  var _a, _b, _c, _d, _e;

  return {
    container: Object.assign({
      display: 'flex',
      flexDirection: 'row'
    }, (_a = theme === null || theme === void 0 ? void 0 : theme.Tabs) === null || _a === void 0 ? void 0 : _a.container),
    borderBottom: Object.assign({
      background: (_b = theme === null || theme === void 0 ? void 0 : theme.colors) === null || _b === void 0 ? void 0 : _b.primary,
      bottom: 0,
      height: 4,
      left: 0,
      position: 'absolute',
      right: 0
    }, (_c = theme === null || theme === void 0 ? void 0 : theme.Tabs) === null || _c === void 0 ? void 0 : _c.borderBottom),
    tab: Object.assign(Object.assign(Object.assign({
      cursor: 'pointer',
      display: 'flex'
    }, StyleUtils_1.default.margin('0 10px')), {
      position: 'relative'
    }), (_d = theme === null || theme === void 0 ? void 0 : theme.Tabs) === null || _d === void 0 ? void 0 : _d.tab),
    text: Object.assign(Object.assign({
      alignSelf: 'center'
    }, StyleUtils_1.default.padding('0 5px')), (_e = theme === null || theme === void 0 ? void 0 : theme.Tabs) === null || _e === void 0 ? void 0 : _e.text)
  };
};

exports.style = style;